const LANDING_PAGE_COOKIE_NAME = 'logisticsLandingPage';

export default {
    LANDING_PAGE_COOKIE_NAME, // Define here as well so we have access to it in the test suite
    ifCookieExists( name ) {
        return !!document.cookie
            .split( '; ' )
            .find( ( row ) => row.startsWith( `${ name }=` ) );
    },
    getLandingPageCookieValue() {
        const cookieArray = document.cookie.split( '; ' );
        const returnCookieWithName = cookieArray.find( ( row ) => row.startsWith( `${ this.LANDING_PAGE_COOKIE_NAME }=` ) );
        const cookieValue = returnCookieWithName ? returnCookieWithName.split( '=' )[ 1 ] : '';
        return this.ifCookieExists( this.LANDING_PAGE_COOKIE_NAME )
            ? cookieValue
            : '';
    },
    setLandingPageCookie( route ) {
        document.cookie = `${ this.LANDING_PAGE_COOKIE_NAME }=${ route }; path=/;`;
    },
    deleteLandingPageCookie() {
        document.cookie = `${ this.LANDING_PAGE_COOKIE_NAME }=;expires=Thu, 01 Jan 1970 00:00:00 UTC`;
    },
};
